import { RouterModule, Routes } from '@angular/router';

import {
    AnschriftComponent,
    BankdatenComponent,
    BeitragWithRateComponent,
    CanDeactivateGuardService,
    DownloadComponent,
    GuardService,
    StandardAntragComponent,
    StandardBeitragComponent,
} from '@vhv/tarifrechner-common';

import { BaugeraeteZusammenfassungComponent } from '../views/antrag/baugeraete-zusammenfassung.component';
import { StartComponent } from '../views/start/start.component';

import { BaugeraeteBeitragComponent } from '../views/beitrag/baugeraete-beitrag.component';
import { BaugeraeteAnfrageDankeComponent } from '../views/antrag/baugeraete-anfrage-danke.component';
import { BaugeraeteErrorComponent } from '../views/error/baugeraete-error.component';
import { BaugeraeteDankeComponent } from '../views/antrag/baugeraete-danke.component';


const routes: Routes = [
    {
        path: "intro",
        pathMatch: "full",
        component: StartComponent,
    },
    {
        path: "beitrag/:seitenName",
        component: StandardBeitragComponent,
        canActivate: [GuardService]
    },

    {
        path: "beitragRate/:seitenName",
        component: BeitragWithRateComponent,
        canActivate: [GuardService]
    },
    {
        path: "beitragErgebnis/:seitenName",
        component: BaugeraeteBeitragComponent,
        canActivate: [GuardService]
    },
    {
        path: "antrag/:seitenName",
        component: StandardAntragComponent,
        canActivate: [GuardService]
    },
    {
        path: "bankdaten/:seitenName",
        component: BankdatenComponent,
        canActivate: [GuardService]
    },
    {
        path: "anschrift/:seitenName",
        component: AnschriftComponent,
        canActivate: [GuardService]
    },
    {
        path: "download/:seitenName",
        component: DownloadComponent,
        canActivate: [GuardService]
    },
    {
        path: "zusammenfassung/:seitenName",
        component: BaugeraeteZusammenfassungComponent,
        canActivate: [GuardService]
    },
    {
        path: "danke/:seitenName",
        component: BaugeraeteDankeComponent,
        canActivate: [GuardService],
        canDeactivate: [CanDeactivateGuardService]
    },
    {
        path: "dankeAnfrage/:seitenName",
        component: BaugeraeteAnfrageDankeComponent,
        canActivate: [GuardService],
        canDeactivate: [CanDeactivateGuardService]
    },
    {
        path: "error",
        component: BaugeraeteErrorComponent
    },
    {
        path: "**",
        redirectTo: "/",
        pathMatch: "full"
    }
];

export const AppRouting = RouterModule.forRoot(routes, { enableTracing: false });
